module.exports = __webpack_public_path__ + "img/ip.34010b1b.png";